import { render, staticRenderFns } from "./InstructionalStatusForm.vue?vue&type=template&id=c1a78b5a&scoped=true"
import script from "./InstructionalStatusForm.vue?vue&type=script&lang=js"
export * from "./InstructionalStatusForm.vue?vue&type=script&lang=js"
import style0 from "./InstructionalStatusForm.vue?vue&type=style&index=0&id=c1a78b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a78b5a",
  null
  
)

export default component.exports